import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import SolutionSidebar from '../elements/services/solution-sidebar';

import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_6.jpg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionDrillingProductionSupply extends Component {

    render() {
        return (
            <>
                <Header1 />

                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner1 + ")" }}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Drilling & Production Supply</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Drilling & Production Supply</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2">
                            <div className="container about-video">

                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={6} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Drilling & Production Supply</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>
                                            We supply high-performance drilling equipment, production tools, and 
                                            industrial chemicals required for reliable and efficient well operations.
                                        </p>

                                        <div className="row m-b30">
                                            <div className="col-md-12">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt="" />
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>
                                            We support operators with certified products and complete supply-chain 
                                            reliability for operational continuity.
                                        </p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Drilling equipment supply</li>
                                                    <li>Production tools & accessories</li>
                                                    <li>Industrial chemicals</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Stimulation chemical agents</li>
                                                    <li>Flow assurance additives</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Benefits</h4>
                                        <p>Operators receive quality equipment with full compliance and certification.</p>

                                        <div className="row">
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Certified materials</li>
                                                    <li><i className="flaticon-light-bolt"></i>Continuous supply-chain support</li>
                                                    <li><i className="flaticon-mask"></i>Performance-enhancing additives</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Drilling Equipment</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Complete set of drilling pipes, bits, motors, and handling tools.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Industrial Chemicals</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        A full range of stimulation, flow assurance, and corrosion control chemicals.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        </Accordion>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <Footer1 />

            </>
        );
    }
}

export default SolutionDrillingProductionSupply ;